module.exports = __webpack_public_path__ + "static/media/logout-icon.a2adb8a1.svg";